import { KM_TO_SCENE_METERS, REAL_KM_PER_SCENE_MM } from "./constants";
import type { VisualizationScale } from "../types/astronomy";

export { KM_TO_SCENE_METERS, REAL_KM_PER_SCENE_MM };

/** Escala proporcional verdadeira: 1000 km = 1 mm. */
export const TRUE_SCALE: VisualizationScale = {
  distanceScale: KM_TO_SCENE_METERS,
  radiusScale: KM_TO_SCENE_METERS,
  moonDistanceScale: KM_TO_SCENE_METERS,
};

export function kmToSceneMeters(km: number): number {
  return km * KM_TO_SCENE_METERS;
}

export function sceneMetersToKm(meters: number): number {
  return meters / KM_TO_SCENE_METERS;
}

export function kmToSceneMm(km: number): number {
  return km / REAL_KM_PER_SCENE_MM;
}
